var _rect;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLoginBanner(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 694,
    height: 797,
    viewBox: "0 0 694 797",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 694,
    height: 797,
    fill: "#DCD3D3"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLoginBanner);
export default __webpack_public_path__ + "static/media/login-banner.3e14e13722d1ae59a981b2dbe92bb869.svg";
export { ForwardRef as ReactComponent };